module.exports = __webpack_public_path__ + "images/emoji/hear_no_evil.f40d24b37bd5cf91b5ad.png";